import { TLCLogger } from "../../../js/lib/logger";
import { LibraryThing } from "../ls2pac/widget/LibraryThingWidget";


export const CarouselListService = (function($) {

    var isJSONP = function ( url ) {
        if( url.indexOf( '.jsonp' ) !== -1 ) {
            return true;
        }
        return url.indexOf( "http" ) !== -1 && url.indexOf( window.location.hostname ) === -1;
    };

    var makeRestCall = function ( options ) {
        var ajaxOptions = {
            type:        'GET',
            url:         options.restUrl,
            dataType:    isJSONP( options.restUrl ) ? 'jsonp' : 'json',
            data:        "",
            success:     function ( response, responseString, xhr ) {
                try {
                    if( xhr.statusText !== "abort" ) {
                        options.callback( response, responseString, xhr, ajaxOptions );
                    }
                } catch( e ) {
                    if( options.jsErrorCallback ) {
                        options.jsErrorCallback( e );
                    }
                }
            },
            contentType: "application/json; charset=utf-8",
            complete:    function ( jqXHR, textStatus ) {
                if( textStatus === "timeout" ) {
                    if( options.timeoutHandler )
                        options.timeoutHandler();
                }
                if( options.finallyHandler )
                    options.finallyHandler( jqXHR, textStatus );
            }
        };
        $.ajax( ajaxOptions );
    };


    var hasLocalLargeImage = function(item){
        if(item.localLargeImage === undefined) {
            return false;
        }

        if(item.localLargeImage === null) {
            return false;
        }

        return item.localLargeImage.length > 0;
    };

    var hasListItems = function(items) {
        return items && items.length > 0;
    };

    var getListItems = function(items) {

        var deferred = $.Deferred();

        if(!hasListItems(items)) {
            return deferred.reject();
        }
        // this call is cached
        $.when(LibraryThing.getConfig()).then(function(syndeticsConfig){

            if(syndeticsConfig.active === true) {
                return deferred.resolve(items);
            }

            var validItems = items.filter(function(listItem) {
                return hasLocalLargeImage(listItem);
            });

            if(validItems.length === 0) {
                return deferred.reject();
            }

            return deferred.resolve(validItems);

        });

        return deferred.promise();
    };

    const requestList = function(listUrl) {
        var deferred = $.Deferred();
        var listData = null;

        makeRestCall({
            restUrl:        listUrl,
            callback:       function ( data ) {
                if(data.resources && data.resources.length > 0) {
                    listData = data.resources;
                }
            },
            finallyHandler: function(){
                if(listData) {
                    return deferred.resolve(listData);
                }

                return deferred.reject();
            }
        });

        return deferred.promise();
    };

    var getList = function(list) {
        var deferred = $.Deferred();

        $.when(requestList(list.url)).then(function(items){
            $.when(getListItems(items)).then(function(listItems){
                list.listItems = listItems;
                return deferred.resolve(list);
            }, function(){
                list.listItems = null;
                return deferred.resolve(list);
            });
        }, function(){
            list.listItems = null;
            return deferred.resolve(list);
        });

        return deferred.promise();
    };

    var getAllLists = function(lists) {
        var deferred = $.Deferred();

        var getarray = [],
            i, len;

        for (i = 0, len = lists.length; i < len; i += 1) {
            getarray.push(getList(lists[i]));
        }

        $.when.apply($, getarray).done(function () {
            var args = Array.prototype.slice.call(arguments); // ES6 Array.from(arguments); equivalent
            return deferred.resolve(args.filter(function(arg){
                return arg.listItems != null;
            }));
        });

        return deferred.promise();
    };

    var getLandingPageConfig = function(baseUrl){
        var deferred = $.Deferred();
        var lists = null;

        makeRestCall( {
            restUrl:        baseUrl + '/landingPageConfiguration',
            callback:       function ( data ) {
                lists = data.resourceLists;
                TLCLogger.log( data.resourceLists );
            },
            finallyHandler: function () {
                return getAllLists(lists).then(function(lists){
                    return deferred.resolve(lists);
                });
            }
        } );
        return deferred.promise();
    };


    return {
        getLists: function(baseUrl){
            return getLandingPageConfig(baseUrl);
        }
    }
})(jQuery);